import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

export default defineStore('configStore', {
	state: () => {
		return {
			electronMode: false, // 当前是否以客户端模式运行
			fullScreen: true, // 当前是否全屏
			registration: {
				mode: []
			},
			webrtc: {},
			agoraAppId: '',
			maxVideoSizeMb: 50
		}
	},
	actions: {
		setConfig(config) {
			this.webrtc = config.webrtc;
			this.registration = config.registration;
			this.agoraAppId = config.agoraAppId || '';
			this.maxVideoSizeMb = config.maxVideoSizeMb || 50;
		},
		setElectronMode(mode) {
			this.electronMode = mode
		},
		setFullScreen(fullScreen) {
			this.fullScreen = fullScreen;
		},
		switchFullScreen() {
			this.fullScreen = !this.fullScreen;
		},
		async loadConfig() {
			const config = await http({
				url: '/system/config',
				method: 'get'
			});
			// 正式环境建议屏蔽以下日志，避免泄露服务器信息
			console.log("系统配置", config)
			this.setConfig(config);
		}
	}
});